const showForScreens = ['home'];

export default { showForScreens };
